import { SET_FILTER, SET_IS_FILTER_OPENED, SET_FILTER_RESULT_COUNT } from "../actions/actiontypes";

const isEmpty = require("is-empty");

const initialState = {
  isOpened: false,
  data: {},
  totalCount: 0
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_FILTER:
      if (isEmpty(action.payload))
      return {
        ...state,
        data: {}
      }
      return {
        ...state,
        data: {...state.data, ...action.payload}
      };
    case SET_IS_FILTER_OPENED:
      return {
        ...state,
        isOpened: action.payload
      };
    case SET_FILTER_RESULT_COUNT:
      return {
        ...state,
        totalCount: action.payload
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./client/src/reducers/Filter.js